// extracted by mini-css-extract-plugin
module.exports = {"replies":"tweet-replies_replies__1DEIU","link":"tweet-replies_link__bBB0L","text":"tweet-replies_text__Ap4WV"};